import React from "react";
import { useHistory } from "react-router-dom";
import { Button as NewButton } from "components/Graphs/Button";
import LaunchableInteractive from "./LaunchableInteractive";

const LaunchableListHeader: React.FC = () => {
  const history = useHistory();

  return (
    <div className="flex flex-col items-center justify-center py-12 rounded-md p-6 my-4 w-auto mx-auto">
      <div className="mb-8">
        <LaunchableInteractive
          isSectionInfoEnabled={false}
          isAnimationEnabled={true}
        />
      </div>
      <div className="flex flex-col items-center max-w-3xl text-center mb-4">
        <h1 className="text-base font-bold text-white mb-4">
          Create Your First Launchable
        </h1>
        <p className="text-sm text-secondary max-w-xl">
          Package your compute, containers, and networking into a shareable URL
          — perfect for showcasing AI workflows, demos, and GPU-accelerated
          software.
        </p>
      </div>

      <div className="flex flex-col items-center gap-4">
        <NewButton
          onClick={() => {
            history.push("/launchables/create");
          }}
        >
          Create My First Launchable
        </NewButton>

        <a
          href="https://docs.nvidia.com/brev/latest/launchables.html"
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-secondary hover:text-white transition-colors"
        >
          View documentation →
        </a>
      </div>
    </div>
  );
};

export default LaunchableListHeader;
